import {HttpService} from "./HttpService";
import {AxiosResponse} from "axios";

export class AdminHttpService {


    static URL_ADMIN_OPERATORS = "/admin/operators"
    static URL_ADMIN_LOGGED_EVENT = "/admin/loggedEvent"
    static URL_ADMIN_INSURANCE_PROVIDERS = "/admin/insuranceProviders"
    static URL_ADMIN_CONTRACTS = "/admin/contract"
    static URL_ADMIN_VOUCHERS = "/admin/vouchers"
    static URL_ADMIN_VOUCHERS_DISCOUNTS = "/admin/vouchers/discounts"
    static URL_ADMIN_PROCEDURES = "/admin/procedures"

    static async get<T>(path:string, criteria?:any,): Promise<AxiosResponse<any, any>> {
        return await HttpService.getLuxotticaAxios().get<T>(path, {
            params: criteria
        });
    }

    static async getWithPostMethod<T>(path:string, criteria?:any,): Promise<AxiosResponse<any, any>> {
        return await HttpService.getLuxotticaAxios().post<T>(path, criteria);
    }

    static async create<T>(path:string, object:any): Promise<AxiosResponse<any, any>> {
        return await HttpService.getLuxotticaAxios().post<T>(`${path}`,object);
    }


}
